import * as Yup from "yup";

export const formValidationBank = Yup.object().shape({
    bank_id: Yup.string().required("Bank is required !"),
    branch: Yup.string().required("Branch is required !"),
    account_number: Yup.string().required("Account bank number is required !"),
    account_name: Yup.string().required("Account bank name is required !"),
});
